module.exports = __webpack_public_path__ + "img/christian_h.e065d32c.jpg";